module.exports = {
  INIT: 'init',
  SUBMITTED: 'submitted',
  PAID: 'paid',
  COMPLETED: 'completed',
  VALIDATED: 'validated',
  CANCELLED: 'cancelled',
  RATED: 'rated',
  REFUSED: 'refused',
};
